var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.requestManager.anyPending)?_c('LoadingIcon'):(_vm.name)?[(_vm.baseUrl)?_c('RouterLink',{attrs:{"to":_vm.redirectTo}},[_vm._v(" "+_vm._s(_vm.name)+" ")]):_c('span',{staticClass:"client-name"},[_vm._v(_vm._s(_vm.name))])]:_c('span',[_vm._v("N/A")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }